import { defineMessages } from 'react-intl';

export const CUSTOM_FEEDBACK_MESSAGES = defineMessages({
  wrong_instructions: {
    id: 'feedback_wrong_instructions',
    defaultMessage: 'Some instructions were wrong',
  },
});
